import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Asset } from '../entities/assets/asset.entity';
import { Imageformat } from '../entities/assets/imageformat.entity';
//#endregion

@Injectable()
export class ImageformatService extends ODataEntityService<Imageformat> {
  constructor(protected client: ODataClient) {
    super(client, 'Imageformat', 'entities.assets.Imageformat');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public assets(entity: EntityKey<Imageformat>): ODataNavigationPropertyResource<Asset> {
    return this.entity(entity).navigationProperty<Asset>('assets');
  }
  //#endregion
}
